module.exports = __webpack_public_path__ + "static/media/Admin-7.acfb0668.png";